import React from 'react';
import { compose } from 'recompose';
import { reduxForm, Field, FormSection } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Select } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import { renderToggleInput } from '../../components/forms/Toggle';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';

const styles = theme => ({});

const enhance = compose(
  withStyles(styles),
  withRouter,
  reduxForm({ form: 'changeSettingsForm', enableReinitialize: true }),
);

const required = value => (value || value === false ? undefined : 'Vyžadováno');

const fields = [
  { name: "name", label: "Název" },
  { name: "address", label: "Adresa" },
  { name: "identificationNumber", label: "IČO" },
  { name: "taxIdentificationNumber", label: "DIČ" },
  { name: "mail", label: "E-mail" },
  { name: "phone", label: "Telefon" },
  { name: "web", label: "Webové stránky" },
]

const optionsFields = [
  { name: "endOfSeason", label: "Konec sezóny" },
  { name: "printFormat", label: "Formát tisku", select: true, options: [{value: "PAPER_ROLL80x297", label: "PAPER_ROLL80x297"}, {value: "A4", label: "A4"}] },
]
const smtpFields = [
  { name: "authorization", label: "Autorizace", boolean: true },
  { name: "contactEmail", label: "E-mail" },
  { name: "contactSubject", label: "Předmět" },
  { name: "host", label: "Host" },
  { name: "password", label: "Heslo" },
  { name: "port", label: "Port" },
  { name: "sender", label: "Odesílatel" },
  { name: "ssl", label: "SSL", boolean: true },
  { name: "tls", label: "TLS", boolean: true },
  { name: "user", label: "Uživatel" },
]

const smtpOptionsFields = [
  { name: "emailTextTemplate", label: "Šablona e-mailu" },
  { name: "rentalConditionsPdf", label: "Šablona podmínek" },
  { name: "sendEnabled", label: "Povolit odeslání", boolean: true },
]

const renderField = (field) => {
  if(field.select) {
    return <Field
    name={field.name}
    component={(props) => (
      <FormControl style={{width: "100%"}}>
        <InputLabel htmlFor={field.name}>{field.label}</InputLabel>
        <Field name={field.name} component={Select} placeholder={field.name}>
          {field.options.map((item2) => (
            <MenuItem key={item2.value} value={item2.value}>
              {item2.label}
            </MenuItem>
          ))}
        </Field>
      </FormControl>
    )}
  />
  } else {
    return <Field
          name={field.name}
          type="text"
          component={field.boolean ? renderToggleInput : TextField}
          label={field.label}
          validate={[required]}
          fullWidth={true}
        />
  }
}

// Response
// {"name":"Rezervační systém - vývoj a test","address":"Ulice 1, Město, PSČ","identificationNumber":"IČO","taxIdentificationNumber":"DIČ","phone":"739801060 (731164318)","mail":"vas@email.cz","web":"https://www.vasweb.cz","options":{"endOfSeason":"30.4.","printFormat":"PAPER_ROLL80x297","smtp":{"authorization":true,"user":"info@sportjezek.cz","password":"h.g?qprI#A`FV`r@:Dd8","host":"wes1-smtp.wedos.net","port":587,"sender":"info@sportjezek.cz","ssl":true,"tls":false,"contactSubject":"Helpdesk požadavek od zákazníka: Sport Ježek","contactEmail":"zavoralm@gmail.com","options":{"sendEnabled":true,"rentalConditionsPdf":"data/email/Vseobecne-podminky-pujcovny-ZIMA.pdf","emailTextTemplate":"data/email/emailTexts.json"}}}}


export default enhance(({ classes, handleSubmit, setAddUser, history }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <Grid container spacing={24}>
      {fields.map(field => <Grid item key={field.name} xs={3}>
        {renderField(field)}
      </Grid>)}
    </Grid>
    
    <FormSection name="options">
      <h3 style={{marginTop: 36}}>Další nastavení</h3>
      <Grid container spacing={24}>
        {optionsFields.map(field => <Grid item key={field.name} xs={3}>
          {renderField(field)}
        </Grid>)}
      </Grid>
      
      <FormSection name="smtp">
        <h3 style={{marginTop: 36}}>Nastavení SMTP</h3>
        <Grid container spacing={24}>
          {smtpFields.map(field => <Grid item key={field.name} xs={3}>
            {renderField(field)}
          </Grid>)}
        </Grid>

        <FormSection name="options">
          <Grid container spacing={24}>
            {smtpOptionsFields.map(field => <Grid item key={field.name} xs={3}>
              {renderField(field)}
            </Grid>)}
          </Grid>
        </FormSection>

      </FormSection>
    </FormSection>
    <div style={{ margin: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        Uložit
      </Button>
      <Button variant="contained" color="secondary" onClick={() => history.push('/')}>
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/account/changeSettingsForm.js